import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/i18n";
import App from "./App";
import "./styles/globals.css";
import { initGA } from "./analytics/analytics";

initGA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
